import { TriangleAlert } from 'lucide-react';
import { isCameraAvailable } from '@/lib/camera';

/**
 * The reduced-capability notice, shown only when this browser cannot open
 * a camera at all (CAPTURE_JOBS.md section 6). Returns null otherwise, so
 * mounting it unconditionally is always safe.
 *
 * It used to list every platform gap, and every iPhone met it on every
 * screen: no `BarcodeDetector`, no zoom constraint, no Background Sync.
 * None of those stops a capture any more. Barcodes decode in JavaScript
 * where the native detector is missing (`lib/barcode.ts`), "Use phone
 * camera" hands zoom and lens choice to the native camera, and the upload
 * queue's foreground behaviour is stated on the queue screen, where it
 * applies. A warning shown to everyone for things that work is one nobody
 * reads when it matters.
 */
export function DegradedNotice() {
  if (isCameraAvailable()) return null;

  return (
    <div
      role="status"
      className="flex items-start gap-2 rounded-card border border-warning bg-transparent p-4 text-sm text-warning"
    >
      <TriangleAlert className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <div className="min-w-0">
        <p className="font-medium">Reduced capability on this device</p>
        <p>This browser cannot open the camera. Choose a photo from the device instead.</p>
      </div>
    </div>
  );
}
